export default function templateDataSelector(func) {
  return func((state) => state.templateReducer);
}
